import { createContext } from "react";
import { IModalFunctionFromModal } from "../components/CDataModal";

export const ModalContext = createContext<IModalFunctionFromModal>(null!);
